import styled from '@emotion/styled'

import Text from './Text'

export default styled(Text)`
  font-style: italic;
`
